import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ColumnDataSourceUpdate, ConfilictColumn } from '../../../models/confilict-column.model';
import { ColumnType } from '../../../models/column-type.type';
import { DataSource } from '../../../models/data-source.modol';
import { DataSourceFacade } from '../../../facade/data-source.facade';
import { Subscription } from 'rxjs';
import { SubmitType } from '../../../../shared/models/submit.type';

@Component({
  selector: 'tart-date-source-conflict-dialog',
  templateUrl: './date-source-conflict-dialog.component.html',
  styleUrls: ['./date-source-conflict-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateSourceConflictDialogComponent implements OnInit {

  warnings: string[];
  columns: ConfilictColumn[];

  subscriptions: Subscription[] = [];
  submitState: SubmitType;
  dataSource: DataSource;
  selectedColumns: ColumnDataSourceUpdate[] = [];
  selecteAllCurrentData = true;

  constructor(
    private dialogRef: NbDialogRef<any>,
    private dataSourceFacade: DataSourceFacade) { }

  ngOnInit(): void {
    this.columns.forEach(column => {
      this.selectedColumns.push({
        id: column.id,
        name: column.name,
        dataType: column.currentType,
      });
    });

    this.subscriptions.push(this.dataSourceFacade.getDataSource$().subscribe(
      (dataSource) => {
        this.dataSource = dataSource;
      },
    ));
    this.subscriptions.push(this.dataSourceFacade.getSubmitState$().subscribe(
      (submitState) => {
        this.submitState = submitState;
        if (this.submitState === 'submitted') {
          this.dataSourceFacade.setSubmitState('notSubmitted');
          this.close();
        } else if (this.submitState === 'submittedWithError') {
          this.dataSourceFacade.setSubmitState('notSubmitted');
        }
      },
    ));
  }

  masterSelect(isAllCurrentData: boolean): void {
    this.selectedColumns.forEach((column, i) => {
      column.dataType = isAllCurrentData ? this.columns[i].currentType : this.columns[i].sourceType;
    });
  }

  checkAllSelectionState(): void {
    if (this.selectedColumns.every((column, i) => column.dataType === this.columns[i].currentType)) {
      this.selecteAllCurrentData = true;
    } else if (this.selectedColumns.every((column, i) => column.dataType === this.columns[i].sourceType)) {
      this.selecteAllCurrentData = false;
    } else {
      this.selecteAllCurrentData = null;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  updateColumns(): void {
    this.dataSourceFacade.updateDatasourceData(this.dataSource.workspaceId, this.dataSource.id, this.selectedColumns);
  }
}
